import {Component, Vue} from "vue-property-decorator";
import { get, isEmpty } from "lodash";
import {AuthStore} from "@/modules/auth/store";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {FreightService} from "@/interfaces/entity";
import {FORMAT_DATE_TIME_PICKER, FORMAT_NUMBER_EXCEL} from "@/shared/constant";
import moment from "moment";


@Component({
    name: "CommonMixin"
})
export default class extends Vue {
    FORMAT_NUMBER_EXCEL = FORMAT_NUMBER_EXCEL;
    getProp = (obj: any, path: string, defaultVal?: any) => get(obj, path, defaultVal) || defaultVal;
    publicPath = process.env.VUE_APP_BASE_PUBLIC_PATH;
    public isEmpty = isEmpty;
    get isAdmin() {
        return AuthStore.hasRoleSystem;
    }
    get freightServiceDefault() {
        const freightService = Object.values(FreightServiceStore.data).find((item: FreightService) => item.serviceCode.includes('CPN'));
        return freightService?.rowGuid;
    }
    get currentPostOffice() {
        return AuthStore.user?.employee?.postOffice;
    }
    get logo() {
        return `${process.env.VUE_APP_NAME}logo.png`;
    }
    get appName() {
        return process.env.VUE_APP_NAME;
    }
    get emailAddress() {
        return process.env.VUE_APP_EMAIL;
    }
    get websiteName() {
        return process.env.VUE_APP_WEBSITE;
    }
    get hotline() {
        return process.env.VUE_APP_HOTLINE;
    }
    buildAddress(data: any) {
        return data ? (data?.address +
            (data?.ward?.name ? ', ' + data?.ward?.name : '') +
            (data?.district?.name ? ', ' + data?.district?.name : '') +
            (data?.province?.name ? ', ' + data?.province?.name : '')) : '';
    }
    buildServiceAdds(services: Array<any>) {
        return services?.map(service => service.name).join(', ');
    }
    calculateVatFee(totalFee: number) {
        return Math.round((totalFee/1.1)*0.1);
    }
    get showWeight() {
        return !!AuthStore?.user?.customer?.showWeight
    }
    buildCurrency(number) {
        return number ? number.toLocaleString('en-US') : '';
    }
    calculateTotalFeeNotVat(totalFee: number) {
        return Math.round((totalFee/1.1));
    }
    getDateFromPayCollectUpdateBy(field, payCollectUpdateBy: any) {
        return payCollectUpdateBy ? JSON.parse(payCollectUpdateBy)[field]?.date : '';
    }
    getDateTimeFromMls(dateMls: number) {
        return dateMls ? moment(dateMls).format(FORMAT_DATE_TIME_PICKER) : '';
    }
}
